module.exports = __webpack_public_path__ + "static/media/8043830519_9ff0a236cd_z.d452529e.jpg";